import axios from 'axios'

let url = ''
if (process.env.NODE_ENV == "development") {
    url = '/api'
} else {
    url = 'https://data.ctpaas.com';
}

export const instance = axios.create();
instance.defaults.timeout = 60000;

instance.defaults.baseURL = url

// post请求头
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
instance.defaults.headers.post['Cache-Control'] = 'no-cache';

// 请求拦截
instance.interceptors.request.use(function (config) {

    return config;

}, function (error) {

    return Promise.reject(error);
});

// 响应拦截
instance.interceptors.response.use(function (response) {
    // console.log('请求响应：', response);

    return response.data
}, function (error) {
    console.log('请求错误：', error.response);
    return response
});

export default {
    install(Vue, opts = {}) {
        Vue.prototype.$http = instance
    }
}



// WEBPACK FOOTER //
// ./src/axios/axios.js